'use client';

import { useEffect, useState } from 'react';

import { IProduct } from '@/services/types';

export type ProductQtySelectorProps = {
  product: IProduct & { id: string };
  initialQty?: number;
  maxQty?: number;
  minQty?: number;
  className?: string;
  onQuantityChange?: (quantity: number) => void;
};

const ProductQtySelector: React.FC<ProductQtySelectorProps> = ({ product, initialQty = 1, maxQty = 10, minQty = 1, className = '', onQuantityChange }) => {
  const [quantity, setQuantity] = useState(initialQty);

  // Notify parent when quantity changes
  useEffect(() => {
    if (onQuantityChange) {
      onQuantityChange(quantity);
    }
  }, [quantity, onQuantityChange]);

  const increaseQty = () => {
    if (quantity < maxQty) {
      setQuantity(quantity + 1);
    }
  };

  const decreaseQty = () => {
    if (quantity > minQty) {
      setQuantity(quantity - 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= minQty && value <= maxQty) {
      setQuantity(value);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <label className="block text-sm font-medium mb-2 text-gray-700">Cantidad:</label>
      <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
        <button
          onClick={decreaseQty}
          disabled={quantity <= minQty}
          className="px-4 py-2 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-gray-700 font-semibold"
        >
          -
        </button>
        <input type="number" value={quantity} onChange={handleInputChange} min={minQty} max={maxQty} className="w-16 text-center border-0 focus:ring-2 focus:ring-primary text-gray-900 font-medium" />
        <button
          onClick={increaseQty}
          disabled={quantity >= maxQty}
          className="px-4 py-2 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-gray-700 font-semibold"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default ProductQtySelector;
